import React from 'react';
import classnames from 'clsx';
import { HAS_CUSTOM_FOCUS_CLASSNAME } from '@wix/editor-elements-common-utils';

import { SearchSymbol } from '../searchSymbol';
import { ISearchBoxLayoutProps } from '../../SearchBoxLayout';
import style from './SearchButton.scss';

type SearchButtonProps = Pick<
  ISearchBoxLayoutProps,
  'searchButtonLabel' | 'onFocus'
>;
export function SearchButton({
  searchButtonLabel,
  onFocus,
}: SearchButtonProps) {
  return (
    <button
      aria-label={searchButtonLabel}
      className={classnames(style.button, HAS_CUSTOM_FOCUS_CLASSNAME)}
      onFocus={onFocus}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <SearchSymbol />
    </button>
  );
}
